import { render } from "./PortalLogout.vue?vue&type=template&id=17b8ab69"
import script from "./PortalLogout.vue?vue&type=script&lang=js"
export * from "./PortalLogout.vue?vue&type=script&lang=js"

import exportComponent from "/runner/_work/cb-checkout/cb-checkout/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__